import React from 'react';
import PropTypes from 'prop-types';
import { Form, FormLabel } from '@edx/paragon';

import { getConfig } from '@edx/frontend-platform';
import { getLocale, injectIntl, intlShape } from '@edx/frontend-platform/i18n';

import messages from './messages';

const LanguageSelector = ({ intl, handleSelectLanguage }) => {
  const showLanguageSelector = getConfig().SHOW_HEADER_LANGUAGE_SELECTOR;
  const availableLanguages = getConfig().SITE_LANGUAGES;

  if (!showLanguageSelector) { return null; }

  return (
    <form className="language-selector-form">
      <Form.Group className="language-selector mb-0" size="sm">
        <FormLabel>{intl.formatMessage(messages.languageLabel)}:</FormLabel>
        <Form.Control
          name="country"
          as="select"
          value={getLocale()}
          onChange={(e) => handleSelectLanguage(e.target.value)}
        >
          {availableLanguages && Object.keys(availableLanguages).map((languageCode) => (
            <option
              key={languageCode}
              value={languageCode}
            >
              {availableLanguages[languageCode]}
            </option>
          ))}
        </Form.Control>
      </Form.Group>
    </form>
  );
};

LanguageSelector.propTypes = {
  intl: intlShape.isRequired,
  handleSelectLanguage: PropTypes.func.isRequired,
};

export default injectIntl(LanguageSelector);
